import React, { useState, useEffect } from 'react';
import { Html5QrcodeScanner } from "html5-qrcode";
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import { FaQrcode, FaCheckCircle, FaUser, FaEnvelope, FaInfoCircle } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

// function getCookie(name) {
//     let cookieValue = null;
//     if (document.cookie && document.cookie !== '') {
//         const cookies = document.cookie.split(';');
//         for (let i = 0; i < cookies.length; i++) {
//             const cookie = cookies[i].trim();
//             if (cookie.substring(0, name.length + 1) === (name + '=')) {
//                 cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
//                 break;
//             }
//         }
//     }
//     return cookieValue;
// }

const ScanEntry = () => {
    const location =useLocation();
    const eventId=location.state?.eventId;
    console.log(eventId);
    
    const [scannedData, setScannedData] = useState(null);
    const [userData, setUserData] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const activeEventId = eventId || 6;

    useEffect(() => {
        console.log("Current Event ID being passed:", eventId);
        const scanner = new Html5QrcodeScanner("reader", { 
            fps: 10, 
            qrbox: { width: 200, height: 200 }, 
            rememberLastUsedCamera: true
        });

        scanner.render(async (decodedText) => {

            if (isProcessing) return;

            setIsProcessing(true);

            try {

                const cleanPasscode = decodedText.trim();

                const res = await API.post(
                    'admin/get-passcode-details/',
                    {
                        passcode: cleanPasscode,
                        event_id: activeEventId
                    }
                );

                setUserData({
                    ...res.data,
                    passcode: cleanPasscode,
                    eventId: res.data.event_id
                });

                if (res.data.next_status === "COMPLETED") {
                    toast.warning(
                        res.data.message ||
                        "This attendee has already exited the event."
                    );
                }

            } catch (err) {

                toast.error(
                    err.response?.data?.error ||
                    "Invalid Passcode!"
                );

            } finally {

                setIsProcessing(false);

            }

        });

        return () => { scanner.clear().catch(console.error); };
    }, [eventId]);

    const handleConfirm = async () => {
        setIsProcessing(true);
        try {
            const res = await API.post('admin/save-entry/', {
                passcode: userData.passcode,
                event_id: activeEventId
            });// { headers: { 'X-CSRFToken': getCookie('csrftoken') } });
            
            toast.success(res.data.message);
            setUserData(null); 
        } catch (err) {
            toast.error(err.response?.data?.error || "Entry Failed!");
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 p-4 md:p-8 font-sans">
            <div className="max-w-5xl mx-auto bg-white rounded-3xl border shadow-sm overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-2">
                    
                    
                    <div className="p-6 md:p-10 border-b md:border-b-0 md:border-r border-gray-100">
                        <h2 className="text-2xl font-black text-[#032167] flex items-center gap-3 mb-4">
                            <FaQrcode /> QR Entry Scanner
                        </h2>
                        <div id="reader" className="w-full max-w-[400px] mx-auto rounded-2xl border-2 border-dashed border-[#032167]/20 overflow-hidden bg-gray-50"></div>
                    </div>

                    
                    <div className="p-6 md:p-10 bg-gray-50/30">
                        {!userData ? (
                            <div className="h-full flex flex-col items-center justify-center text-gray-400 gap-4 min-h-[300px]">
                                <FaQrcode size={48} className="opacity-20" />
                                <p>Please scan a QR code to view details.</p>
                            </div>
                        ) : (
                            <div className="space-y-6 animate-in fade-in duration-500">
                                <div className="flex items-center gap-4">
                                    <div className="h-16 w-16 rounded-full bg-[#032167] text-white flex items-center justify-center text-2xl">
                                        <FaUser />
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-black text-[#032167]">Visitor Verified</h3>
                                        <p className="text-sm text-gray-500">Entry authorization details</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 gap-3">
                                    <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                        <p className="text-xs text-gray-400 uppercase tracking-wider">Participant Name</p>
                                        <p className="font-bold text-[#032167] text-lg">{userData.cust_name}</p>
                                    </div>
                                    <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                        <p className="text-xs text-gray-400 uppercase tracking-wider">Email Address</p>
                                        <p className="font-medium text-gray-700">{userData.cust_id}</p>
                                    </div>
                                    <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                        <p className="text-xs text-gray-400 uppercase tracking-wider">Event</p>
                                        <p className="font-bold text-black">{userData.event_name}</p>
                                    </div>
                                    <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                        <p className="text-xs text-gray-400 uppercase tracking-wider">Pass Code</p>
                                        <p className="font-mono font-bold text-[#032167]">{userData.passcode}</p>
                                    </div>
                                    
                                    {userData.next_status === "COMPLETED" ? (
                                        <div className="mt-2 p-4 rounded-xl border border-red-200 bg-red-50 text-center">
                                            <p className="text-[10px] text-gray-500 uppercase tracking-[2px]">Status</p>
                                            <h2 className="text-2xl font-black text-red-600">ALREADY EXITED</h2>
                                            <p className="text-sm text-gray-600 mt-2">Cycle completed for today.</p>
                                        </div>
                                    ) : (
                                        <div className={`mt-2 p-4 rounded-xl border text-center ${userData.next_status === "IN" ? "bg-green-50 border-green-200" : "bg-orange-50 border-orange-200"}`}>
                                            <p className="text-[10px] text-gray-500 uppercase tracking-[2px]">Next Action</p>
                                            <h2 className={`text-2xl font-black ${userData.next_status === "IN" ? "text-green-600" : "text-orange-600"}`}>
                                                MARK AS {userData.next_status}
                                            </h2>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-6 flex flex-col gap-3">
                                    {userData.next_status !== "COMPLETED" && (
                                        <button
                                            onClick={handleConfirm}
                                            disabled={isProcessing}
                                            className="w-full bg-[#032167] text-white py-4 rounded-2xl font-bold hover:bg-blue-900 transition"
                                        >
                                            {isProcessing ? "Processing..." : `Confirm ${userData.next_status}`}
                                        </button>
                                    )}
                                    <button
                                        onClick={() => setUserData(null)}
                                        className="w-full border border-gray-300 py-3 rounded-2xl text-gray-600 hover:bg-gray-100"
                                    >
                                        Scan Another QR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScanEntry;